import { Type } from '@angular/core';
import { AbstractFormFieldComponent } from '../../../Common/PageBuilder/components/FormField/abstract-form-field.component';
import { FormFieldModel } from '../../../Common/PageBuilder/models/form-field.model';
import { DisplayElementModel } from './display-element.model';

export class BooleanRadioFieldModel implements FormFieldModel {
    fieldComponent: Type<AbstractFormFieldComponent>;
    property: string;
    labelTrue: string;
    labelFalse: string;
    appearCondition: (displayElement: DisplayElementModel) => boolean;

    constructor(
        fieldComponent: Type<AbstractFormFieldComponent>,
        property: string,
        labelTrue: string,
        labelFalse: string,
        appearCondition?: (displayElement: DisplayElementModel) => boolean,
    ) {
        this.fieldComponent = fieldComponent;
        this.property = property;
        this.labelTrue = labelTrue;
        this.labelFalse = labelFalse;
        this.appearCondition = appearCondition;
    }
}
